import { en } from "./translations.en";
import { fr } from "./translations.fr";
import { pt } from "./translations.pt";

export const translations = {
  en: {
    giftCards: en,
  },
  fr: {
    giftCards: fr,
  },
  pt: {
    giftCards: pt,
  },
};
